import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';
import { LogisticService, StockplaceItem } from '@app/services/logistic.service';
import { RememberService } from '@app/core/services/remember.service';
import { Item } from '@app/core/components/listbox/listbox.component';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';

@Component({
    selector: 'tt-custact-calc-pick',
    templateUrl: './custact-calc-pick.component.html',
    styleUrls: ['./custact-calc-pick.component.css'],
    standalone: false,
})
export class CustactCalcPickComponent implements OnInit {
    @Input()
    public params?: GetCustactCalcPickParams;

    public info?: InfoGet;
    
    public setting?: CustactCalcPickGet;
    
    public selectListStockPlaces: StockplaceItem[] = [];

    public itemsListComponents: Item[] = [];

    constructor(
        private datatask: DataTaskService,
        private logistic: LogisticService,
        private rememberService: RememberService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }
    
    private async loadInfo() {
        if (!!this.params?.custact_no) {
            this.info = (await this.datatask.Post(28, { custact_no: this.params?.custact_no }))[0];
        }
    }
    
    private async loadSetting() {
        if (!!this.params) {
            this.setting = (await this.datatask.Post(874, this.params))[0];
        }
    }
    
    private async loadStockPlaces() {
        if (!this.setting) return;

        if (!!this.setting.businessco_no) {
            this.selectListStockPlaces = await this.logistic.getStockplaces({ businessco_no: this.setting.businessco_no });
        }
    }

    private async loadComponents() {
        if (!this.setting) return;

        if (!!this.params && !!this.setting?.stockplace_id) {
            this.itemsListComponents = await this.datatask.Post(872, {
                ...this.params,
                bg_custactcalc_view: this.setting.bg_custactcalc_view,
                stockplace_id: this.setting.stockplace_id
            });
        }
    }

    private async retrieveScan() {
        if (!this.setting) return;

        if (!!this.setting.stockplace_id) {
            const response = (await this.datatask.Post(455, {
                functionname: 'trmenu',
                barcode: this.setting.filtervalue,
                stockplace_id: this.setting.stockplace_id
            }))[0];

            this.navigator?.go({
                to: response?.webpagename,
                parms: response?.parms
            });
        }
    }
    
    public async goToFunc(state: any) {
        if (!this.setting) return;

        switch (state) {
            case 'productsearch':
                this.rememberService.remember('w_custactcalcpick.filtervalue_new', this.setting!.filtervalue);
                await this.retrieveScan();
                break;
            default:
                break;
        }
    }

    public onChanged(_: string, id: keyof CustactCalcPickGet) {
        if (!this.setting) return;

        switch (id) {
            case 'stockplace_id':
                this.loadComponents();
                break;
            default:
                break;
        }
    }

    public onTabChanged() {
        this.loadComponents();
    }
    
    private async init() {
        this.loadInfo();
        await this.loadSetting();
        this.rememberService.remember('w_custactcalcpick.p2PoFinishKeyno', this.params?.custact_no);
        
        Promise.all([
            this.loadStockPlaces(),
            this.loadComponents(),
        ]);
    }

    ngOnInit() {
        if (!!this.navigator) {
            this.params = this.navigator.params as any;

            this.init();
        }
    }
}

interface GetCustactCalcPickParams {
    p2_pofinish_keyno: string;
    custact_no: string;
}

interface InfoGet {
    note: string;
    text_sales: string;
    text_production: string;
    drawing_no: string;
    nbr_of_documents: string;
    custact_no: string;
    nbr_of_pictures: string;
}

interface CustactCalcPickGet {
    filtervalue: string;
    bg_custactcalc_view: string;
    stockplace_id: string;
    businessco_no: string;
}
